import { stringKeyToTuple } from 'js/lib/stringKeyTuple';

import { enroll } from 'bundles/course-sessions/utils/onDemandSessionsApi';

import type { EnrollingCourse } from '../types/EnrollingCourse';

/**
 * enrollInMultipleCourses - Loops over an array of courses and enrolls in each one
 * @param {EnrollingCourse[]} enrollingCourses - Courses to enroll in
 * @returns {Promise<EnrollingCourse[]>} An array of courses that were successfully enrolled in
 */

export const enrollInMultipleCourses = async (enrollingCourses: EnrollingCourse[]): Promise<EnrollingCourse[]> => {
  const sessionIds: string[] = enrollingCourses.map((enrollingCourse: EnrollingCourse) => {
    return stringKeyToTuple(enrollingCourse.session.id).pop() as string;
  });
  const enrollmentPromises = sessionIds.map((sessionId: string) => {
    return enroll(sessionId)
      .then((resp) => {
        return resp.elements[0].id;
      })
      .catch((error) => {
        return error;
      });
  });

  return Promise.all(enrollmentPromises)
    .then((resps) => {
      // just in case, filter out enrollment session if it request failed
      const successfullyEnrolledSessionSet = new Set(resps.filter((id) => id));
      return (
        enrollingCourses
          // Filter out courses that weren't enrolled in
          .filter((course: EnrollingCourse) => {
            return successfullyEnrolledSessionSet.has(course.session.id);
          })
      );
    })
    .catch((error) => {
      return error;
    });
};

export default enrollInMultipleCourses;
